const priceInfoArr = [
  {
    label: '医生服务',
    key: 'serviceAttribution'
  },
  {
    label: '图文咨询服务',
    key: 'doctorDefaultConsultFeeConfigList',
    type: 'graphic',
    itemStyle: {
      alignItems: 'baseline'
    },
    valueStyle: {
      textAlign: 'right'
    }
  },
  {
    label: '电话咨询服务',
    key: 'doctorPhoneDefaultConsultFeeConfigList',
    type: 'phone',
    itemStyle: {
      alignItems: 'baseline'
    },
    valueStyle: {
      textAlign: 'right'
    }
  },
  {
    label: '视频咨询服务',
    key: 'doctorVideoDefaultConsultFeeConfigList',
    type: 'video',
    itemStyle: {
      alignItems: 'baseline'
    },
    valueStyle: {
      textAlign: 'right'
    }
  },
  {
    label: '按患者设置图文咨询',
    key: 'thisPatientChargeString'
  },
  // {
  //   label: '默认问诊费',
  //   key: 'defaultCharge'
  // },
  {
    label: '患者首次咨询免费',
    key: 'firsCureFree'
  }
  // {
  //   label: '医生发起问诊默认免费',
  //   key: 'doctorAddCureFree'
  // },
]

export { priceInfoArr }
